import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Button } from '../button/button.component';
import { modelKeys, SimplifiedFooterProps } from './simplified-footer.config';
import { getModels, useChildComponents } from '../../utils/use-child-components';

const SimplifiedFooter = ({ additionalClasses, cqPath, isInEditor, ...props }: SimplifiedFooterProps) => {
  const { t } = useTranslation();

  const childComponents = useChildComponents(
    cqPath,
    getModels({ cqPath, isInEditor, ...props }, modelKeys),
    { isInEditor },
    {
      twitter: {
        appliedCssClassNames: 'snowflake-button-icon',
      },
      linkedin: {
        appliedCssClassNames: 'snowflake-button-icon',
      },
      facebook: {
        appliedCssClassNames: 'snowflake-button-icon',
      },
      youtube: {
        appliedCssClassNames: 'snowflake-button-icon',
      },
    }
  );

  return (
    <div className={classNames('snowflake-simplified-footer-wrapper', additionalClasses)}>
      <div className="snowflake-container snowflake-simplified-footer" data-testid="snowflake-simplified-footer">
        <div className="snowflake-footer-links-grid">
          {childComponents?.privacy_notice && (
            <div
              data-testid="snowflake-simplified-footer-privacy-notice"
              className="snowflake-footer-text snowflake-button-tertiary snowflake-button-white snowflake-footer-link-item snowflake-footer-privacy-notice"
            >
              {childComponents?.privacy_notice}
            </div>
          )}
          {childComponents?.site_terms && (
            <div
              data-testid="snowflake-simplified-footer-site-terms"
              className="snowflake-footer-text snowflake-button-tertiary snowflake-button-white snowflake-footer-link-item snowflake-footer-site-terms"
            >
              {childComponents?.site_terms}
            </div>
          )}
          <div className="snowflake-footer-text snowflake-button-tertiary snowflake-button-white snowflake-footer-link-item snowflake-footer-cookie-settings">
            <Button className="optanon-toggle-display" disableAnchor text={t('cookie_settings')} />
          </div>
          {childComponents?.additional_buttons_container && (
            <div
              data-testid="snowflake-simplified-footer-additional-buttons"
              className="snowflake-footer-text snowflake-button-tertiary snowflake-button-white snowflake-footer-additional-buttons"
            >
              {childComponents.additional_buttons_container}
            </div>
          )}
        </div>
        {childComponents?.text && (
          <div className="snowflake-simplified-footer-copyright-grid">
            <div
              data-testid="snowflake-simplified-footer-copyright-text"
              className="snowflake-footer-text text-color-text-04 "
            >
              {childComponents?.text}
            </div>
          </div>
        )}
        <div className="snowflake-simplified-footer-socials-grid">
          {childComponents?.twitter && (
            <div
              data-testid="snowflake-simplified-footer-twitter"
              className="snowflake-button-icon snowflake-button-white snowflake-footer-social-item"
            >
              {childComponents.twitter}
            </div>
          )}
          {childComponents?.linkedin && (
            <div
              data-testid="snowflake-simplified-footer-linkedin"
              className="snowflake-button-icon snowflake-button-white snowflake-footer-social-item"
            >
              {childComponents.linkedin}
            </div>
          )}
          {childComponents?.facebook && (
            <div
              data-testid="snowflake-simplified-footer-facebook"
              className="snowflake-button-icon snowflake-button-white snowflake-footer-social-item"
            >
              {childComponents.facebook}
            </div>
          )}
          {childComponents?.youtube && (
            <div
              data-testid="snowflake-simplified-footer-youtube"
              className="snowflake-button-icon snowflake-button-white snowflake-footer-social-item"
            >
              {childComponents.youtube}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimplifiedFooter;
